import { render, staticRenderFns } from "./AuditInstructionFiles.vue?vue&type=template&id=271fa52e"
import script from "./AuditInstructionFiles.vue?vue&type=script&lang=ts"
export * from "./AuditInstructionFiles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports